// extracted by mini-css-extract-plugin
module.exports = {"scannedTable":"InputResourcesScannedTable_scannedTable__3O06d","noData":"InputResourcesScannedTable_noData__1_ep0"};